import { Box, Paper, Typography } from "@mui/material";

export const ErrorPaper = ({ message }) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography variant="body" sx={{ my: 3 }}>
          {message}
        </Typography>
      </Box>
    </Paper>
  );
};
